<template>
    <div class="vx-row">
        <div class="vx-col w-full mb-base">
            <vx-card class="mb-6" :title="$t('MonthlyWorkingHours') | ToUppercase">
            <vs-button class="" color="success" type="filled" to="/monthly-working-hours/add">{{$t('AddMonthlyWorkingHours')}}</vs-button>
            
            <vs-table :noDataText="$t('NoMonthlyWorkingHoursFound')" max-items="14" pagination search :data="monthlyWorkingHours">
                <template slot="thead">
                    <vs-th sort-key="id">#</vs-th>
                    <vs-th sort-key="id">{{ $t("Date") }}</vs-th>
                    <vs-th sort-key="id">{{ $t("Actions") }}</vs-th>
                </template>
                <template slot-scope="{data}">
                    <tbody>
                        <vs-tr :data="tr" :key="data[index].id" v-for="(tr, index) in data">
                            <vs-td>{{ data[index].id}}</vs-td>
                            <vs-td>{{ data[index].date_formated}}</vs-td>
                            <vs-td class="grid justify-items-start">
                                <vs-button v-if="data[index].lock_edit == 1" disabled class="float-left mr-2"color="primary" @click="$router.push('/monthly-working-hours/edit/' + data[index].id)" type="border" icon="build" >{{$t('Edit') | ToUppercase}}</vs-button>
                                <vs-button v-else class="float-left mr-2"color="primary" @click="$router.push('/monthly-working-hours/edit/' + data[index].id)" type="border" icon="build" >{{$t('Edit') | ToUppercase}}</vs-button>
                                <vs-button class="float-left" v-if="data[index].excel_name != ''" color="primary" @click="excelClick(data[index].excel_name)" type="border" icon="table_chart">{{$t('Download') | ToUppercase}}</vs-button>
                            </vs-td>
                        </vs-tr>
                    </tbody>
                </template>
            </vs-table>
            </vx-card>
        </div>
    </div>
</template>
<script>
    export default {
        filters: {
            ToUppercase: function (value) {
                if (!value) return "";
                value = value.toString();
                return value.toUpperCase();
            },
        },
        components: {
        },
        data() {
            return {
                monthlyWorkingHours: [],
            };
        },
        methods: {
            updateMonthlyWorkingHours() {
                this.$vs.loading();

                const thisIns = this;
                this.$http.get('/monthly-working-hours/')
                .then(function (response) {
                    thisIns.monthlyWorkingHours = response.data;
                }).catch(function () {
                    thisIns.$vs.notify({
                        text: "Napaka pri pridobivanju mesečnih oddelanih ur",
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    })
                }).finally(function () {
                    thisIns.$vs.loading.close();
                });
            },
            excelClick(excelName) {
                window.open('/api/excel/report/' + excelName + '?type=monthlyWorkingHours');
            },
        },
        created() {
            this.updateMonthlyWorkingHours();
        },
    };
</script>